<template>
  <v-overlay class='user-settings-overlay' :model-value="overlay" :persistent="true">
    <v-progress-circular
          indeterminate
          color="accent"
          :size="60"
    ></v-progress-circular> 
  </v-overlay>
  <v-main style="padding-top:50px;">
    <v-dialog
      v-model="cropperDialogIsOpen"
      width="auto"
      persistent
    >
      <v-card>
        <cropper
          ref="cropperRef"
          class="cropper"
          :stencil-component="CircleStencil"
          image-restriction="fit-area"
          default-boundaries="fit"
          :src="image.src"
          @change="change"
        />
        <v-btn
          variant="flat" plain color="accent" class="crop-image-btn"
          @click="cropImage()"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>    
      </v-card>
    </v-dialog>
    <v-container v-show="pageLoaded" style="max-width:500px; margin-left:0px;">
      <div class="top-section">
        <span v-if="numProfileItemsComplete !== 'all'" class="progress-linear-text">{{ profileIncompleteText }}</span>
        <v-progress-linear v-if="numProfileItemsComplete !== 'all'" style="margin-bottom:10px;" color="accent" :model-value="profilePercentageComplete"></v-progress-linear>
        <v-alert
          v-if="numProfileItemsComplete !== 'all'"
          class="fill-in-profile-alert"
          v-model="alert"
          border="start"
          close-label="Close Alert"
          color="accent-4"
          variant="tonal"
          closable
        >
          {{ profileProgressText }}
        </v-alert>
         <v-alert
          v-if="!numPublishedPaddles"
          class="fill-in-profile-alert"
          v-model="alert"
          border="start"
          close-label="Close Alert"
          color="accent-4"
          variant="tonal"
          closable
        >
          <p>Add a route and earn a first contributor badge</p>
          <p style="font-weight:400">Unlock a first look at future features and help shape the future of the platform.</p>
        </v-alert>
      </div>
      <div class="avatar-wrapper">
        <div ref="imageUploadDiv" class="image-upload-div"></div>
        <p style="font-size:12px;color:red;margin-left:10px;" v-if="showFileValidation">Max file size 5MB</p>
        <!-- <div class="button-wrapper"> -->
        <v-btn variant="flat" plain color="accent" class="button upload-avatar-btn" size="small"
 @click="fileRef.click()">
          <input
            ref="fileRef"
            type="file"
            @change="uploadImage($event)"
            accept="image/*"
          />
          Upload avatar
        </v-btn>
        <v-progress-circular
          v-if="avatarUploadInProgress"
          indeterminate
          color="accent"
          class="avatar-upload-in-progress"
        ></v-progress-circular> 
      </div>
      <p class="hint">After uploading click save to save changes.</p>
        <!-- <button class="button" @click="cropImage()">Crop image</button> -->
      <!-- </div> -->
      <v-text-field
        v-model="displayName"
        label="Username"
        class="mb-2"
        required
        filled
        outlined
        density="compact"
        validate-on-blur
      ></v-text-field>
      <v-textarea
        v-model="aboutMe"
        label="About Me"
      ></v-textarea>
        <v-btn variant="flat" plain color="accent" class="button save-btn" :disabled="avatarUploadInProgress" @click="saveProfile()">
          Save
        </v-btn>
    </v-container>
    <div v-show="!pageLoaded" class="spinner-container">
      <v-progress-circular
        indeterminate
        color="accent"
        :size="60"
      ></v-progress-circular>
    </div>
  </v-main>
</template>

<script>
  import NODE_API from '../utils/api';
  import constants from '../utils/constants'; 
  import NavBar from '../components/NavBar.vue';
  import { Auth } from 'aws-amplify';
  import ConfirmDialog from '../components/ConfirmDialog.vue';
  import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
  import { nextTick } from 'vue';
  const API_KEY = process.env.VUE_APP_API_KEY;
  import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
  import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
 import { defineComponent, ref, reactive, onUnmounted } from "vue";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import {getResizedCanvas} from '../utils/files'; 

  export default {
    name: 'UserProfile',
    components: {
      NavBar,
      ConfirmDialog,
      Cropper,
    },
    props: {
      userId: String,
      isInDialog: Boolean
    },
    emits: ['close'],
    async created() {
      this.user = await Auth.currentAuthenticatedUser(); 
      if (!this.user) {
        this.$router.push('/'); 
      } else {
       
        try {
          let response = await NODE_API.get(`${constants.amazonGatewayUrl}/userMetadata?username=${this.user.username}&profile=true`);
          this.userMetadata = response.data.ret;     
        
          if (!this.userMetadata) {
            //this can happen if the user object wasn't added to mongo - 
            //the post confirmation handler didn't fire. 
            //which could happen for those users who we manually imported, and reset passwords for
          } else {
            this.displayName = (this.user.attributes && this.user.attributes.preferred_username) ? this.user.attributes.preferred_username : this.user.attributes.name; 
            this.aboutMe = this.userMetadata.aboutMe; 
            this.userObjectId = this.userMetadata._id; 
            this.theAvatarFilePath = this.userMetadata.avatarFilePath; 
            this.numPublishedPaddles = this.userMetadata.numPublishedPaddles; 
     
            let body = JSON.stringify({
              filePath: this.userMetadata.avatarFilePath,
              type: 'getObject',
              userImage: true 
            }); 
      
            try {
                //signed url for get avatar
                let signedUrlResponse = await NODE_API.post(`${constants.amazonGatewayUrl}/getSignedUrl`, body,{
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }); 

                let backgroundImageUrl = signedUrlResponse.data.uploadUrl; //should not be called uploadUrl in this case. its for the get.     
                const avatarCircle = document.querySelector('.image-upload-div'); 
                avatarCircle.style.backgroundImage = `url(${backgroundImageUrl})`; 
          
            } catch (e) {
                console.error('could not load avatar',e); 
            }
          }
        } catch (e) {
          console.error(e); 
        }
        
        this.pageLoaded = true; 
      } 
    },
    mounted() {
    },
    setup() {
      const cropperRef = ref();
      const fileRef = ref();
      let cropperDialogIsOpen = ref(false); 
      let showFileValidation = ref(false); 
      let avatarUploadInProgress = ref(false); 
      const image = reactive({
        src:"",
        type:""
      });
      console.log('image',image); 
      onUnmounted(() => {
        // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (image.src) {
          URL.revokeObjectURL(image.src);
        }
      });

      return {
        CircleStencil,
        cropperRef,
        fileRef,
        cropperDialogIsOpen,
        showFileValidation,
        image,
        avatarUploadInProgress,
        change(result) {
          console.log(result);
        },
        async cropImage() {
          const { canvas } = cropperRef.value.getResult();

          if (canvas) {  
            avatarUploadInProgress.value = true; 
            const backgroundImageUrl = canvas.toDataURL(); 
            const avatarCircle = document.querySelector('.image-upload-div'); 
            avatarCircle.style.backgroundImage = `url(${backgroundImageUrl})`; 
            cropperDialogIsOpen.value = false; 
            
            canvas.toBlob(async (blob) => {
              //get type and extension from the original upload
              const originalFile = fileRef.value.files[0]; 
              //get aws signed url 
              const matches = originalFile.name.match(/\.([a-zA-Z0-9]+)$/)
              const extension = (matches) ? matches[1] : 'txt'; 
              const user = await Auth.currentAuthenticatedUser(); 
              const usernameSlug = user.username.toLowerCase().replace(/ /g,'-'); 
              //get signed URL to upload to Amazon bucket 
              let body = JSON.stringify({
                type: 'putObject', 
                extension,
                mime: originalFile.type || 'application/octet-stream',
                userImage: true,
                username: usernameSlug
              }); 

              try {
                //get signed url for upload
                let signedUrlResponse = await NODE_API.post(`${constants.amazonGatewayUrl}/getSignedUrl`, body,{
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }); 
 
                let {uploadUrl, filePath} = signedUrlResponse.data; 

                //apart from cropping, resize canvas so we're not uploading images that are bigger than they need to be
                let shrunkCanvas = await getResizedCanvas(blob,500,500); 

                shrunkCanvas.toBlob(async (blob2) => {
                   let avatarFile = new File([blob2], 'avatar');
                  //got the signed url. Now actually upload to S3 bucket. 
                  let options = {
                    headers: {
                      'Content-Type': avatarFile.type
                    }
                  };
                  let uploadResponse = await NODE_API.put(uploadUrl, avatarFile, options);   
                  this.theAvatarFilePath = filePath;   
                  console.log('the avatar file path',this.theAvatarFilePath); 
                  avatarUploadInProgress.value = false;                 
                }); 
          
              } catch (e) {
                 console.error('Could not upload image',e); 
                 avatarCircle.style.backgroundImage = ''; 
              }
            });
          }
        },
        async uploadImage(event) {
          const maxAllowedSize = 5 * 1024 * 1024; // 5 MB in bytes
          /// Reference to the DOM input element
          const { files } = event.target;
          // Ensure that you have a file before attempting to read it
          if (files && files[0]) {
            if (files && files[0].size > maxAllowedSize) {
              showFileValidation.value = true; 
              event.target.value = ''; // Reset the input field
              return; 
            }
            // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
            if (image.src) {
              URL.revokeObjectURL(image.src);
            }

            const blob = URL.createObjectURL(files[0]);

            // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
            image.src = blob;
            image.type = files[0].type;
            cropperDialogIsOpen.value = true; 
           
          }
        }
      }
    },
    methods: { 
      async saveProfile() {
        const usernameSlug = this.user.username.toLowerCase().replace(/ /g,'-'); 
        let body = {
          id: this.userObjectId, 
          preferredUsername: this.displayName, 
          aboutMe: this.aboutMe,
          avatarFilePath: this.theAvatarFilePath,
          username: usernameSlug
        };

        body = JSON.stringify(body); 

        this.overlay = true; 
        await nextTick(); 
        try {
          let updateSettingsResponse = await NODE_API.put(`${constants.amazonGatewayUrl}/userMetadata/profile`,body, {
              headers: {
                'Content-Type': 'application/json'
              }
            });
        } catch (e) {
          console.error(e); 
        }
        this.overlay = false; 
      },
    },
    computed: {
      numProfileItemsComplete() {
        if (!this.aboutMe && !this.theAvatarFilePath) {
          return 1; 
        } else if (!this.aboutMe || !this.theAvatarFilePath){
          return 2; 
        } else {
          return 'all'; 
        }
      },
      profileProgressText() {
        let textArray = []; 
        if (!this.theAvatarFilePath) {
          textArray.push('upload a profile picture'); 
        }
        if (!this.aboutMe) {
          textArray.push('fill in about me'); 
        }

        let string = textArray.join(', '); 
        return `${string[0].toUpperCase()}${string.slice(1)}`;
      },
      profilePercentageComplete () {
        if (this.numProfileItemsComplete === 1) {
          return 33; 
        } else if (this.numProfileItemsComplete === 2) {
          return 66; 
        } else {
          return 100; 
        }
      },
      profileIncompleteText() {
        if (this.numProfileItemsComplete === 1) {
          return 'Profile 1/3 complete'; 
        } else if (this.numProfileItemsComplete === 2) {
          return 'Profile 2/3 complete'; 
        }
        return ''; 
      }, 
    },
    data: () => ({  
      userObjectId: null, 
      user: null,
      displayName: '',
      aboutMe: '',
      showErrorMessage: '',
      errorMsg: '',
      pageLoaded: false,
      overlay: false,
      dialog:false, 
      theAvatarFilePath: '',
      userMetadata: null,
      numPublishedPaddles: null
    }),
  }
</script>

<style lang="scss">
  .user-settings-overlay {
    .v-overlay__content {
      left: 50%;
      top: 50%;
      margin-left: -30px;
      margin-top: -30px;
    }
    .v-overlay__scrim {
      opacity:0.5; 
    }
  } 
</style>

<style lang="scss" scoped>
.top-section {
  font-size: 14px;
  margin-bottom:20px; 
  font-weight: bold;
}
.fill-in-profile-alert {
  font-weight: bold;
  font-size: 14px; 
  margin-bottom:10px; 
}
.progress-linear-text {
  color:rgb(var(--v-theme-accent)); 
  font-weight:500; 
}
.avatar-upload-in-progress {
  position: absolute;
  right: 5px;
  bottom: -1px;
  width: 21px;
}
.hint {
  font-size:12px; 
  line-height:14px; 
  display:block; 
  text-align:left; 
  padding-left:5px; 
  padding-bottom:5px; 
  color:gray; 
  margin-bottom:10px; 
  
}
.avatar-wrapper {
  width:200px; 
  margin-bottom:10px; 
  position:relative; 
}
.crop-image-btn {
  position: absolute;
  width: 50px;
  color: white !important;
  padding: 0px;
  font-size: 20px;
  bottom:10px; 
  right:10px; 
}
.image-upload-div {
  margin: 0 auto 10px; 
  background-size: cover; 
  background-position: center; 
  background-repeat: no-repeat;
}
.upload-avatar-btn {
  font-size: 12px!important;
  padding: 0px 0px!important;
  min-width: 0px;
  width: 130px !important;
  color:white!important;
  margin:0 auto;
  display:block;
}
.save-btn {
  color:white!important;
  width:200px!important; 
}
.cropper {
  max-height: 500px;
  max-width:500px;
}
.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  width: 100%;
  background: #151515;
  cursor: pointer;
  transition: background 0.5s;
  border: none;
  &:not(:last-of-type) {
    margin-right: 10px;
  }
  &:hover {
    background: #2F2F2F;
  }
  input {
    display: none;
  }
}
  #minimap {
    width:250px; 
    height:300px; 
  }
  #geocoder {
    z-index: 1;
    margin-left: 10px;
    margin-top:-10px; 
  }
  .mapboxgl-ctrl-geocoder {
    min-width: 100%;
  }
  .save-user-settings-btn {
    margin-top:35px; 
  }
  .error-msg {
    min-height:0px!important;
    font-size:12px;
    line-height:15px;
    color: rgb(var(--v-theme-error)); 
  }
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
  }
  .settings-location-hint {
    font-size: 12px;
    vertical-align: middle;
    padding-top: 29px;
    display: inline-block;
    padding-left: 20px;
    max-width:300px; 
  }
  .image-upload-div {
    background-color:lightgray;  
    border-radius: 50%;
    cursor: pointer;
    height: 100px;
    width: 100px;
    margin-bottom: 10px;
  }
</style>
